import React from 'react';
import CompanyType from "@SearchResults/types/company/Company.type";
import RouteActiveTicketContextType from "@Route/features/mobile/types/RouteActiveTicketContext.type";
import MobileRouteTravelDetails from "@Route/features/mobile/components/MobileRouteTravelDetails";
import MobileCompanyDetails from "@Route/features/mobile/components/MobileCompanyDetails";
import MobileRouteAmenities from "@Route/features/mobile/components/MobileRouteAmenities";
import MobileRouteStations from "@Route/features/mobile/components/MobileRouteStations";
import MobileDiscountsSection from "@Route/features/mobile/components/MobileDiscountsSection";
import MobileSummarySection from "@Route/features/mobile/components/MobileSummarySection";
import ParamsType from "@SearchResults/types/params/Params.type";
import {useScroll} from "@Scroll/hooks/useScroll";
import usePrepareRouteForAdditionalInfo
    from "@SearchResults/features/additionalInfo/hooks/usePrepareRouteForAdditionalInfo";
import PassengerGroupType from "@SearchResults/types/passenger/PassengerGroup.type";
import RouteType from "@Route/types/Route.type";
import {isEmpty} from "@Array/isEmpty";
import MobilePassengerClasses from "@Route/features/mobile/components/MobilePassengerClasses";
import {useScrollToTopOnMount} from "@Scroll/hooks/useScrollToTopOnMount";
import MobileContentContainer from "@Route/features/mobile/components/MobileContentContainer";
import SeatClass from "@Route/components/SeatClass/SeatClass";

interface RouteMobileAdditionalInfoProps {
    route: RouteType
    activeTicketSections: RouteActiveTicketContextType,
    displayActionButton?: boolean,
    params: ParamsType,
    isReturn: boolean,
    companies: Record<number, CompanyType>,
    passengerGroups: Record<number, PassengerGroupType>,
}

const RouteMobileAdditionalInfo = (props: RouteMobileAdditionalInfoProps) => {
    const {
        route,
        activeTicketSections,
        displayActionButton = true,
        params,
        isReturn,
        companies,
        passengerGroups,
    } = props

    const {
        ticketInfoSection,
        companySection,
        amenitiesSection,
        travelInfoSection,
        discountsSection,
        seatClassSection,
    } = activeTicketSections

    const {prepareRoute} = usePrepareRouteForAdditionalInfo({
        companies,
        isReturn,
        passengerGroups,
    })

    const preparedRoute = prepareRoute(route)
    useScrollToTopOnMount()

    return (
        <>
            {!isEmpty(route.passengerClasses) && (
                <MobilePassengerClasses
                    preparedRoute={preparedRoute}
                    params={params}
                    isReturn={isReturn}
                />
            )}
            <MobileRouteTravelDetails
                route={preparedRoute}
                company={preparedRoute.company}
            />
            <MobileCompanyDetails
                route={preparedRoute}
                company={preparedRoute.company}
            />
            {isEmpty(route.passengerClasses) && seatClassSection && (
                <MobileContentContainer
                    title={seatClassSection.title}
                >
                    <SeatClass
                        displayImages
                        displayDescription
                        seatClass={route.travelInfo.seatClass}
                    />
                </MobileContentContainer>
            )}
            {amenitiesSection && (
                <MobileRouteAmenities
                    amenitiesHashMap={preparedRoute.amenitiesHashMap}
                />
            )}
            {travelInfoSection && (
                <MobileRouteStations
                    travelInfo={preparedRoute.travelInfo}
                    routeId={preparedRoute.id}
                />
            )}
            {discountsSection && (
                <MobileDiscountsSection
                    discounts={preparedRoute.prices.discounts}
                />
            )}
            {isEmpty(route.passengerClasses) && displayActionButton && (
                <MobileSummarySection
                    isReturn={isReturn}
                    route={preparedRoute}
                    params={params}
                />
            )}
        </>
    )
}

export default RouteMobileAdditionalInfo
